import { TrackingActionTypes } from '../actions';

export interface State {
  url: string;
  interaction: string;
  currentPage: string;
  errorMsg: string;
  errorIdentifier: string;
  errorCode: string;
  statusCode: number;
  backendError: string;
  devError: string;
  referringLinkLocation: string;
}

export const initialState: State = {
  url: '',
  interaction: '',
  currentPage: '',
  errorMsg: '',
  errorIdentifier: '',
  errorCode: '',
  statusCode: 600,
  backendError: '',
  devError: '',
  referringLinkLocation: '',
};

export function reducer(state = initialState, action: any): State {
  switch (action.type) {
    case TrackingActionTypes.TRACK_TELEMETRY_ERROR:
      return Object.assign({}, state, {
        url: action.payload.url,
        interaction: action.payload.interaction,
        currentPage: action.payload.currentPage,
        errorMsg: action.payload.errorMsg,
        errorIdentifier: action.payload.errorIdentifier,
        errorCode: action.payload.errorCode,
        statusCode: action.payload.statusCode,
        backendError: action.payload.backendError,
        devError: action.payload.devError,
        referringLinkLocation: action.payload.referringLinkLocation,
      });
    case TrackingActionTypes.TRACK_CLEAR_TELEMETRY_ERROR:
        return Object.assign({}, initialState);
    default:
      return state;
  }
}
